import { render, staticRenderFns } from "./JustificationPanel.vue?vue&type=template&id=470c335f&scoped=true"
import script from "./JustificationPanel.vue?vue&type=script&lang=js"
export * from "./JustificationPanel.vue?vue&type=script&lang=js"
import style0 from "./JustificationPanel.vue?vue&type=style&index=0&id=470c335f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c335f",
  null
  
)

export default component.exports